module.exports = __webpack_public_path__ + "slide1-welcomeoctopus.bcc90e1eb68180b4336dcc7dbee7f855.hashedasset.svg";